import type { FC } from 'react';

import type { ComposerAuthor, ComposerDestination, ComposerDestinationMode } from '../../CommunityPostComposer.type';
import { tr } from '../constants';
import { MemberAvatar } from '../MemberAvatar';
import { ComposerFrameHeader } from './ComposerFrame';
import { ComposerSpaceSelector } from './ComposerSpaceSelector';

type ComposerHeaderProps = {
  destinations: ComposerDestination[];
  selectedDestination: ComposerDestination;
  onDestinationChange: (destination: ComposerDestination) => void;
  destinationMode: ComposerDestinationMode;
  author?: ComposerAuthor;
  onClose: () => void;
  translations?: Record<string, string>;
};

export const ComposerHeader: FC<ComposerHeaderProps> = ({
  destinations,
  selectedDestination,
  onDestinationChange,
  destinationMode,
  author,
  onClose,
  translations,
}) => {
  return (
    <ComposerFrameHeader onClose={onClose} closeLabel={tr(translations, 'community.composer.close')}>
      {author && (
        <span className="flex min-w-0 items-center gap-2">
          <MemberAvatar name={author.name} avatarUrl={author.avatarUrl} />
          <span className="max-w-[140px] truncate text-[13px] font-medium leading-4 text-black">{author.name}</span>
        </span>
      )}
      {destinationMode !== 'hidden' && (
        <ComposerSpaceSelector
          destinations={destinations}
          selected={selectedDestination}
          onChange={onDestinationChange}
          translations={translations}
          disabled={destinationMode === 'locked'}
        />
      )}
    </ComposerFrameHeader>
  );
};
